<template>
  <base-section
    id="hero"
    space="0"
  >
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/venice_home_cut_compressed.jpg')"
      class="white--text"
      gradient="to bottom, rgba(11, 28, 61, 0.9), rgba(0,0,0,.5)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          width="100%"
        >
          <base-heading
            size="text-h2"
            weight="medium"
            title="28th IEEE European Test Symposium 2023"
          />

          <base-subheading
            size="text-h3"
            weight="medium"
            title="May 22-26 in Venice, Italy | Hybrid conference"
          />

          <base-body>
            The IEEE European Test Symposium (ETS) is Europe’s premier forum dedicated to presenting and discussing scientific results, emerging ideas, applications, hot topics and new trends in the area of electronic-based circuits and system testing, reliability, security and validation.
          </base-body>

          <div
            :class="'flex-column align-start'"
            class="d-flex flex-wrap"
          >
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="gallery"
            target="_blank"
            >
              Gallery
            </base-btn>
          </v-badge>
          <span class="font-weight-bold ml-6 mr-4 my-4"></span>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            v-if="!isMobileDevice()"
            to="program-conference"
            >
              Program
            </base-btn>
            <base-btn
            v-else
            to="program-calendar"
            >
              Program
            </base-btn>
          </v-badge>
          <span class="font-weight-bold ml-6 mr-4 my-4"></span>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            href="https://docs.google.com/forms/d/e/1FAIpQLSfiMUiGrt6nZNf8i-CylNw64--g5iWfazbAZ7cpQWdTRGFIZQ/formResponse"
            target="_blank"
            >
              Evaluation Form
            </base-btn>
          </v-badge>
          <!---
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            href="https://tss.date.upb.de/tss2023/"
            target="_blank"
            >
              Test Spring School
            </base-btn>
          </v-badge>
          --->
              <span class="font-weight-bold ml-6 mr-4 my-4"></span>
            <base-btn
            to="social-event"
            >
              Social Event
            </base-btn>
            <span class="font-weight-bold ml-6 mr-4 my-4"></span>
            <base-btn
            v-if="!isMobileDevice()"
            href="#/venue#tab-tips-tricks"
            >
              Tips and Tricks
            </base-btn>
            <base-btn
            v-else
            to="tips-tricks"
            >
              Tips and Tricks
            </base-btn>

            <!---
            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
            --->
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </base-section>
</template>

<script>
  import DataService from '../../services/DataService'
  // DataService.getN().then (response => { console.log(response.data)}).catch (e => {console.log(e)})
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'
        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
